<section id="contact-hero-section">
  <section class="say-hello-section">
    <span class="x-large-font font-white">Contact Us</span>
    <p class="body-font bold-font font-white">
      Our staff is here to listen, serve, and support
    </p>
    <p class="underline body-font font-white">
      <a class="text-white" href="mailto: info@medshorts.com"
        >info"&#64;medshorts.com</a
      >
    </p>
    <p class="underline body-font font-white">844-733-5633</p>
    <p class="body-font font-white">
      200 East Robinson Street | Suite 1250 | Orlando, Florida 32801
    </p>
    <section class="social-media">
      <ul>
        <li>
          <a href="https://www.facebook.com/medshorts" target="_blank"
            ><img
              src="/assets/img/static-pages/medshorts/Facebook-icon.png"
              alt="Twitter logo"
          /></a>
        </li>
        <li>
          <a href="https://twitter.com/MedshortsLLC" target="_blank"
            ><img
              src="/assets/img/static-pages/medshorts/Twitter-icon.png"
              alt="Twitter logo"
          /></a>
        </li>
        <li>
          <a href="https://www.instagram.com/medshorts/" target="_blank"
            ><img
              src="/assets/img/static-pages/medshorts/Instagram-icon.png"
              alt="Instagram logo"
          /></a>
        </li>
        <li>
          <a href="https://www.linkedin.com/company/medshorts/" target="_blank"
            ><img
              src="/assets/img/static-pages/medshorts/LinkedIn-icon.png"
              alt="LinkedIn logo"
          /></a>
        </li>
      </ul>
    </section>
  </section>
  <section id="medshorts-map">
    <iframe
      width="100%"
      height="450"
      frameborder="0"
      style="border: 0"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3504.811481439994!2d-81.37759568495102!3d28.5
            45385594770675!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e77afb7722fb5f%3A0xeef6f41324d52feb!
            2s200%20E%20Robinson%20St%2C%20Orlando%2C%20FL%2032801!5e0!3m2!1sen!2sus!4v1608152647834!5m2!1sen!2sus"
      allowfullscreen=""
    ></iframe>
  </section>
</section>
<section class="contact-us-form-section">
  <i *ngIf="!hasMessage && !isUrlTestimonial" style="color: #777777"
    >For general inquiries please fill in the following form:</i
  >
  <i *ngIf="!hasMessage && isUrlTestimonial" style="color: #777777"
    >Submit your testimonial:</i
  >
  <app-static-footer></app-static-footer>
  <div *ngIf="hasMessage && !isUrlTestimonial" class="alert">
    Thanks for the inquiry.
  </div>
  <div *ngIf="hasMessage && isUrlTestimonial" class="alert">
    Thank you for submitting your testimonial.
  </div>
</section>
